import React, { Component } from "react";
import { Checkbox } from "material-ui";
import { Typeahead } from "react-bootstrap-typeahead";
import Tooltip from "rc-tooltip";
import ActionInfo from "material-ui/svg-icons/action/info-outline";
import {
  text_definition,
  primaryColor,
  debounceEventHandler,
} from "../../utils/utility";

import map from "lodash/map";
import intersection from "lodash/intersection";
import isEmpty from "lodash/isEmpty";
import some from "lodash/some";
import filter from "lodash/filter";

const geographicText = (
  <section>
    <div className="mb-10">
      To select an entire state, select that state's checkbox.
    </div>
    <div>To display a state's cities, select that state's row.</div>
  </section>
);
class GeoStatesPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      indexKey: null,
      selectedVal: null,
      selectedStates: [],
    };
  }

  componentWillUnmount() {
    this.setState({
      indexKey: null,
      selectedVal: null,
      selectedStates: [],
    });
  }

  componentDidMount() {
    this.setState({
      indexKey: null,
      selectedVal: null,
      selectedStates: [],
    });
  }

  handleCityChange(selectedItem, cities) {
    if (selectedItem.length > 0) {
      cities.forEach((city, index) => {
        if (city.id === selectedItem[0].id) {
          // compute scrollTop
          //this.refs.cityUl.scrollTop = index * liHeight;
          this.setState({
            beSearchedCityId: selectedItem[0].id,
          });
          this.refs.citiesList.scrollTop = index * 40;
        }
      });
    }
  }

  render() {
    const selectedStateIds = this.props.selected_states
      ? map(this.props.selected_states, s => {
          return s.id;
        })
      : [];
    const checkStates = this.props.displayData
      ? filter(this.props.displayData, state => {
          return selectedStateIds.indexOf(state.id) >= 0;
        })
      : [];

    const isAllStateCitiesCheck =
      !isEmpty(checkStates) &&
      some(checkStates, state => {
        return state.value === this.state.selectedVal;
      });

    let clsName = "mt-10 ml-10 mr-10";
    const cityStateMode = Boolean(this.props.getCities);
    let valueList = null;
    if (cityStateMode) {
      valueList = this.props.cities;
    } else {
      if (this.props.cities) {
        if (this.props.subTitle === 'COUNTY') {
          valueList = filter(this.props.cities, item => {
            return item.label.endsWith(this.state.selectedVal);
          });
        }
        if (this.props.subTitle === 'DMA') {
          valueList = this.props.cities.filter(l => {
            return l.label.substring(l.label.indexOf(',') + 1, l.label.length).indexOf(this.state.selectedVal) >= 0;
          }).filter(item => +item.value !== 999);
        }
      }
    }

    const { selectedVal } = this.state;
    return (
      <div style={{ display: "flex", flexGrow: "1" }}>
        <div
          key={"geo-state-node-contianer"}
          style={{ width: "300px" }}
          className="light-grey-border"
        >
          <div
            className="pt-20 ml-20 mr-20 mb-10 pb-10 light-grey-bottom-border"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div>
              <strong>{this.props.title}</strong>
            </div>
            <div style={{ height: "24px" }}>
              <Tooltip
                placement="right"
                overlay={geographicText}
                arrowContent={<div className="rc-tooltip-arrow-inner" />}
              >
                <div
                  style={{
                    display: "inline-block",
                    color: "#1E88E5",
                    cursor: "pointer",
                  }}
                >
                  <ActionInfo />
                </div>
              </Tooltip>
            </div>
          </div>
          {this.props.showSelectAll && (
            <div className="light-grey-bottom-border mb-10 pb-10 ml-20 mr-20 mt-20">
              <Checkbox
                label={"Select All"}
                labelStyle={{ fontSize: "16px" }}
                iconStyle={{ fill: "#A3A3A3", marginRight: "10px" }}
                checked={
                  this.props.selected_states.length > 0 &&
                  this.props.selected_states.length ===
                    this.props.displayData.length
                }
                onCheck={(e, isInputChecked) => {
                  this.props.selectAllStates(
                    map(this.props.displayData, d => {
                      return d;
                    }),
                    isInputChecked,
                  );
                }}
              />
            </div>
          )}
          <div style={{ height: "390px", overflowY: "scroll" }}>
            {map(this.props.displayData, data => {
              let clsName = " ml-10 mr-10";
              const countiesInState =
                this.props.subTitle === "COUNTY" && this.props.cities
                  ? filter(this.props.cities, item => {
                      return item.label.endsWith(`, ${data.value}`);
                    })
                  : [];
              const selectedCountyIdsInState = intersection(
                map(this.props.selected_cities, "id"),
                map(countiesInState, "id"),
              );
              const hasSelectedCountyInState =
                selectedCountyIdsInState.length > 0;
              const allCountiesInStateSelected =
                countiesInState.length > 0 &&
                selectedCountyIdsInState.length === countiesInState.length;
              const showMark = some(this.props.selected_cities, city => {
                if (cityStateMode) return city.state === data.value;
                if (this.props.subTitle === "COUNTY")
                  return city.label.endsWith(`, ${data.value}`);
                return city.label.indexOf(data.value) >= 0;
              });
              const shouldShowMark =
                this.props.subTitle === "COUNTY"
                  ? hasSelectedCountyInState
                  : cityStateMode
                    ? showMark || selectedStateIds.indexOf(data.id) >= 0
                    : showMark && selectedStateIds.indexOf(data.id) < 0;
              let dataChecked = selectedStateIds.indexOf(data.id) >= 0;
              if (
                (this.props.subTitle === "DMA" ||
                  this.props.subTitle === "COUNTY") &&
                this.props.cities
              ) {
                const vals = filter(this.props.cities, item => {
                  if (this.props.subTitle === "COUNTY") return item.label.endsWith(`, ${data.value}`);
                  return item.label.indexOf(data.value) >= 0;
                });
                if (vals.length > 0)
                  if (this.props.subTitle === "State") {
                    dataChecked =
                        intersection(
                            map(this.props.selected_cities, "id"),
                            map(vals, "id"),
                        ).length === vals.length;
                  }
                  if (this.props.subTitle === "COUNTY") {
                    dataChecked = allCountiesInStateSelected;
                  }

              }

              return (
                <div
                  key={data.label + "_" + data.id}
                  style={{
                    color: "#017FB5",
                    cursor: "pointer",
                    display: "flex",
                  }}
                  className={clsName}
                  onClick={() => {
                    this.setState({
                      indexKey: data.id,
                      selectedVal: data.value,
                    });
                    if (this.props.getCities) this.props.getCities(data.id);
                  }}
                >
                  <div
                    className="p-10 mr-10"
                    style={{
                      background:
                        this.state.indexKey === data.id ? "#F5F5F5" : "#FFF",
                      flexGrow: "1",
                      display: "flex",
                    }}
                  >
                    <Checkbox
                      label={""}
                      labelStyle={{ fontSize: "16px" }}
                      style={{ width: "10px" }}
                      iconStyle={{ fill: "#A3A3A3", marginRight: "10px" }}
                      checked={dataChecked}
                      onCheck={(e, isInputChecked) => {
                        this.props.selectState(data, isInputChecked);
                      }}
                    />
                    <div style={{ flexGrow: "1" }}>{data.label}</div>
                    <div
                      style={{
                        display: shouldShowMark ? "flex" : "none",
                        paddingTop: "4px",
                      }}
                    >
                      <i className="icon-checkmark4 text-orange-400" />
                    </div>
                  </div>
                  <div className="tree-node-arrow-right"></div>
                </div>
              );
            })}
          </div>
        </div>

        {this.state.selectedVal && (
          <div
            key={"geo-state-values-node-contianer"}
            style={{ flexGrow: "1" }}
            className="light-grey-border"
          >
            <div className="pt-20 ml-20 mr-20 mb-10 pb-10 light-grey-bottom-border">
              <strong>{this.props.subTitle}</strong>
            </div>
            {!this.props.ifLoading &&
              valueList &&
              (this.props.subTitle === "DMA" ? (
                <div
                  style={{
                    height: "40px",
                    paddingTop: "10px",
                    background: "rgb(232, 232, 232)",
                    marginLeft: "40px",
                    marginBottom: "20px",
                    marginRight: "20px",
                  }}
                >
                  <span style={{ marginLeft: "10px" }}>
                    <strong>Code</strong>
                  </span>
                  <span style={{ marginLeft: "60px" }}>
                    <strong>DMA</strong>
                  </span>
                </div>
              ) : (
                <div className="ml-20 mr-20 mb-10 pb-20 light-grey-bottom-border">
                  <Typeahead
                    key="city_search_box"
                    labelKey="label"
                    multiple={false}
                    options={
                      this.props.subTitle === "City"
                        ? this.props.cities
                        : valueList
                    }
                    placeholder={
                      this.props.subTitle === "COUNTY"
                        ? "Search Counties"
                        : `Search Cities`
                    }
                    onChange={selectedItem =>
                      this.handleCityChange(selectedItem, this.props.cities)
                    }
                  />
                </div>
              ))}
            <div
              style={{ height: "390px", overflowY: "scroll" }}
              ref={"citiesList"}
            >
              {this.props.ifLoading ? (
                <div style={{ textAlign: "center", paddingTop: "100px" }}>
                  loading...
                </div>
              ) : (
                map(valueList, (city, idx) => {
                  return (
                    <div
                      key={city.label + city.id + "_node"}
                      style={{ color: "#017FB5", cursor: "pointer" }}
                      className={clsName}
                    >
                      <Checkbox
                        label={
                          this.props.subTitle === "DMA" ? (
                            <div
                              style={{ display: "flex", paddingLeft: "20px" }}
                            >
                              <div style={{ width: "50px" }}>{city.value}</div>
                              <div style={{ flexGrow: "1" }}>{city.label}</div>
                            </div>
                          ) : (
                            city.label
                          )
                        }
                        labelStyle={{
                          fontSize: "16px",
                          background:
                            this.state.beSearchedCityId === city.id
                              ? "#C3C3C3"
                              : "#FFF",
                        }}
                        iconStyle={{ fill: "#A3A3A3", marginRight: "10px" }}
                        checked={
                          isAllStateCitiesCheck ||
                          this.props.selected_cities.some(item => {
                            return item.id === city.id;
                          })
                        }
                        disabled={isAllStateCitiesCheck}
                        onCheck={(e, isInputChecked) => {
                          this.props.selectCity(
                            city,
                            this.state.selectedVal,
                            isInputChecked,
                          );
                        }}
                      />
                    </div>
                  );
                })
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

GeoStatesPanel.defaultProps = {
  showSelectAll: true,
};

export default GeoStatesPanel;



// WEBPACK FOOTER //
// ./src/components/AudienceBuilder/GeoStatesPanel.js